import { ColumnDef } from '@tanstack/react-table'
import { FC } from 'react'

import { MakeColumnOptions } from './types'

interface ChannelCellProps {
  name: string
  id: string
}

const ChannelCell: FC<{ channel?: ChannelCellProps }> = (props) => {
  return props.channel ? (
    <span className="whitespace-nowrap">{props.channel.name}</span>
  ) : null
}

export function makeChannelColumnTrpc<D extends UnknownRecord>({
  fieldKey,
  label = 'Channel',
  width,
  minWidth = width,
  maxWidth,
  footer,
}: MakeColumnOptions<D>): ColumnDef<D> {
  return {
    accessorKey: fieldKey,
    id: fieldKey as string,
    cell: (cell) => (
      <ChannelCell
        channel={
          typeof cell.getValue<ID>() === 'string'
            ? (cell.row.original as ChannelCellProps)
            : cell.getValue<ChannelCellProps>()
        }
      />
    ),
    header: label,
    size: width,
    minSize: minWidth,
    maxSize: maxWidth,
    footer,
  }
}
